// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#app {
  height: 100%;
  background-color: white;
  font-family: Poppins, Helvetica, Arial, sans-serif;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;EAGE,YAAY;EACZ,uBAAuB;EACvB,kDAAkD;EAClD,gBAAgB;AAClB","sourcesContent":["html,\nbody,\n#app {\n  height: 100%;\n  background-color: white;\n  font-family: Poppins, Helvetica, Arial, sans-serif;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
